__webpack_require__.p = "https://m.withvector-staging.com/";